<template>
  <v-container fluid>
    <PageHeaderSlot showBackButton />

    <v-form ref="dataForm" @submit.prevent="">
      <v-card>
        <v-card-text class="px-2">
          <v-row class="ma-0">
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormInput
                label="classroomName"
                placeholder="classroomName"
                :fieldValue.sync="formData.name"
                required
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
              />
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="3">
              <FormSelect
                label="campus"
                placeholder="selectCampus"
                :fieldValue.sync="formData.school_id"
                :options="tutorSchoolOptions"
                required
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <div class="d-flex align-center mt-4">
        <FormButton @click="save()" />
        <FormButton
          v-if="$validate.DataValid(id)"
          class="ml-4"
          outlined
          color="error"
          text="delete"
          @click="handleDelete()"
        />
      </div>
    </v-form>
  </v-container>
</template>

<script>
import FormInput from '@/components/formField/FormInput.vue'
import FormSelect from '@/components/formField/FormSelect.vue'

export default {
  name: 'ClassroomDetails',
  inject: ['getConfirmDialogRef'],
  components: {
    FormInput,
    FormSelect,
  },
  computed: {
    id() {
      return this.$validate.regexNumber(this.$route.params.id) ? parseInt(this.$route.params.id) : null
    },
    dispatchUpdateOnChange() {
      return this.$validate.DataValid(this.id)
    },
  },
  data: vm => ({
    userType: vm.gfGetUserType(),
    permissionValid: true,

    formData: {
      name: '',
      school_id: null,
    },
    tutorSchoolOptions: [],
  }),
  methods: {
    async _getClassroomById() {
      try {
        const data = await this.$Fetcher.GetClassroomById(this.id)
        if (this.$validate.DataValid(data.school_id)) {
          const getUserSchools = this.gfGetUserSchools()
          if (!getUserSchools.includes(data.school_id)) {
            this.permissionValid = false
            throw 'message.notBelongClassroomBranch'
          }
        }

        for (const key in this.formData) {
          if (this.$validate.DataValid(data[key])) {
            this.$set(this.formData, key, data[key])
          }
        }
      } catch (err) {
        this.$common.error(err)
        if (err !== 'abort') {
          this.showAlert({
            message: err,
            returnLink: 'ClassroomList',
            isError: true,
          })
        }
      }
    },

    // -- (確認)
    async save() {
      if (!this.permissionValid) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const valid = this.$refs['dataForm'].validate()
      if (!valid) {
        this.$store.dispatch('toggleSnack', { message: 'required' })
        return
      }

      this.$store.dispatch('setLoading', true)
      try {
        const payload = {
          name: this.formData.name,
          school_id: parseInt(this.formData.school_id),
        }

        let message = {}
        if (this.$validate.DataValid(this.id)) {
          await this.$Fetcher.UpdateClassroom(this.id, payload)
          message = {
            message: 'message.saveSuccess',
            refresh: true,
          }
        } else {
          await this.$Fetcher.NewClassroom(payload)
          message = {
            message: 'message.createSuccess',
            redirect: 'ClassroomList',
          }
        }

        this.$store.dispatch('setDataIsUpdated', false)
        this.$store.dispatch('toggleSnack', {
          ...message,
          type: 'success',
        })
      } catch (err) {
        this.$common.error(err)
        this.showAlert({
          title: this.$validate.DataValid(this.id) ? 'message.saveFail' : 'message.createFail',
          message: err,
          isError: true,
        })
      } finally {
        this.$store.dispatch('setLoading', false)
      }
    },

    // -- (刪除)
    async handleDelete() {
      if (!this.permissionValid) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const confirmRef = this.getConfirmDialogRef()
      const confirm = await confirmRef.show({ isDelete: true })
      if (confirm) {
        this.$store.dispatch('setLoading', true)
        try {
          await this.$Fetcher.DeleteClassroom(this.id)
          this.$store.dispatch('toggleSnack', {
            message: 'message.deleteSuccess',
            type: 'success',
            redirect: 'ClassroomList',
          })
        } catch (err) {
          this.$common.error(err)
          this.showAlert({
            title: 'message.deleteFail',
            message: err,
            isError: true,
          })
        } finally {
          this.$store.dispatch('setLoading', false)
        }
      }
    },

    // ======== 分校 Options =======
    async _getTutorSchoolOptions() {
      try {
        const { data } = await this.$Fetcher.GetSchools()
        const filtered = data.filter(el => el.active === true)
        this.tutorSchoolOptions = filtered.map(el => {
          return {
            value: el.id,
            text: el.name,
          }
        })

        // 只會攞staff所屬嘅分校
        const getUserSchools = this.gfGetUserSchools()
        this.tutorSchoolOptions = this.tutorSchoolOptions.filter(el => getUserSchools.includes(el.value))
      } catch (err) {
        this.$common.error(err)
      }
    },

    async handleSiteLoaded() {
      this.$common.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> handleSiteLoaded: ClassroomDetails')
      this.permissionValid = true
      this.userType = this.gfGetUserType()
      await this._getTutorSchoolOptions()

      if (this.$validate.DataValid(this.id)) {
        // edit
        await this._getClassroomById()
      } else {
        // new
        if (this.tutorSchoolOptions.length === 1) {
          this.formData.school_id = this.tutorSchoolOptions[0].value
        } else {
          const selectedSchool = this.gfGetUserSelectedSchool()
          if (selectedSchool > -1) {
            this.formData.school_id = selectedSchool
          }
        }
      }

      this.$store.dispatch('toggleLoadingPage', false)
    },
  },
  destroyed() {
    window.removeEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  mounted() {
    this.$store.dispatch('toggleLoadingPage', true)
    window.addEventListener('onSiteLoaded', this.handleSiteLoaded)
  },

  // ------ navigation guard ------
  beforeRouteLeave(to, from, next) {
    if (this.$store.getters.isLoading) {
      this.$store.dispatch('toggleSnack', { message: 'processing' })
      next(false)
    } else if (this.$store.getters.dataIsUpdated) {
      this.$store.dispatch('showLeaveAlert', { toLink: { name: to.name } })
      next(false)
    } else {
      next()
    }
  },
}
</script>
